import { configureStore } from "@reduxjs/toolkit";
import ui from "./reducers/ui";

const store = configureStore({
    reducer: {
        ui
    }
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export default store;
